import main from './main';
import { loadScript, browserSupportsFeatures } from '@mindkomm/polyfill-loader';

if (browserSupportsFeatures()) {
  main();
} else {
  console.log('Loading polyfills.');
  loadScript(window.themePolyfills.src, main);
}
